import React from 'react';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { t } = this.props;
      return (
        <div className="error-boundary-container">
          <h2 className="error-boundary-title">{t('errorBoundaryTitle') || 'Something went wrong.'}</h2>
          <p className="error-boundary-desc">{t('errorBoundaryDesc') || 'An unexpected error occurred in the application.'}</p>
          <button
            onClick={() => window.location.reload()}
            className="error-boundary-button"
          >
            {t('errorBoundaryAction') || 'Reload Page'}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
